import { useSyncExternalStore } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth'
import type { User } from 'firebase/auth'
import { auth, profileStore, sharedSession } from '@/lib/firebase'
import { demoUser, isDemo } from '@/lib/demo'

const demo = isDemo()
const noop = () => () => {}
const never = () => false

export function useAuth() {
  const [user, loading] = useAuthState(auth)
  // re-render after a name change; the user object itself is mutated in place
  useSyncExternalStore(profileStore.subscribe, profileStore.version)
  // still trying to sign in from the session shared with the city
  const restoring = useSyncExternalStore(sharedSession?.restoringStore.subscribe ?? noop, sharedSession?.restoringStore.get ?? never)
  if (demo) return { user: demoUser as unknown as User, loading: false }
  return { user: user ?? null, loading: loading || (restoring && !user) }
}
